module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component-vehicle-additional-status"
  }, [(_vm.showToolTip) ? _c('div', {
    staticClass: "row align-middle align-center"
  }, [(_vm.item.door_open_status) ? _c('tooltip', {
    staticClass: "has-tip",
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Door: ' + _vm.item.door_open_status
    }
  }, [_c('span', {
    staticClass: "fa fa-exclamation fa-lg",
    class: _vm.status(_vm.item.door_open_status),
    attrs: {
      "id": "door"
    }
  })]) : _vm._e(), (_vm.item.ev_plug_status) ? _c('tooltip', {
    staticClass: "has-tip",
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'ev_plug_status: ' + _vm.item.ev_plug_status
    }
  }, [_c('span', {
    staticClass: "fa fa-plug fa-lg",
    class: _vm.status(_vm.item.ev_plug_status)
  })]) : _vm._e(), (_vm.item.key_status) ? _c('tooltip', {
    staticClass: "has-tip",
    attrs: {
      "open": true,
      "tip": 'key_status: ' + _vm.item.key_status
    }
  }, [_c('span', {
    staticClass: "fa fa-key fa-lg",
    class: _vm.status(_vm.item.key_status)
  })]) : _vm._e(), (_vm.item.immobilizer_status) ? _c('tooltip', {
    staticClass: "has-tip",
    attrs: {
      "open": true,
      "tip": 'immo_status: ' + _vm.item.immobilizer_status
    }
  }, [_c('span', {
    staticClass: "fa fa-link fa-lg",
    class: _vm.status(_vm.item.immobilizer_status)
  })]) : _vm._e()], 1) : _c('div', {
    staticClass: "row align-middle align-center"
  }, [_c('span', {
    staticClass: "fa fa-exclamation fa-lg",
    class: _vm.status(_vm.item.door_open_status)
  }), _c('span', {
    staticClass: "fa fa-plug fa-lg",
    class: _vm.status(_vm.item.ev_plug_status)
  }), _c('span', {
    staticClass: "fa fa-key fa-lg",
    class: _vm.status(_vm.item.key_status)
  }), _c('span', {
    staticClass: "fa fa-link fa-lg",
    class: _vm.status(_vm.item.immobilizer_status)
  }), (_vm.item.battery_voltage) ? _c('span', [_vm._v(" " + _vm._s(_vm.item.battery_voltage) + "V")]) : _vm._e()]), (_vm.item.statuses) ? [_c('div', {
    staticClass: "row align-middle align-center text-center"
  }, _vm._l((_vm.item.statuses), function(value, key) {
    return _c('tooltip', {
      staticClass: "has-tip",
      attrs: {
        "tip": (key + ": " + value)
      }
    }, [_c('mdi-icon', {
      class: _vm.status(value),
      attrs: {
        "name": _vm.getName(key, value),
        "show-name": false
      }
    }, [_c('small', [_vm._v(_vm._s(key) + ": " + _vm._s(value))])])], 1)
  }), 1)] : _vm._e(), (_vm.item.battery_voltage && _vm.showToolTip) ? _c('span', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.item.battery_voltage) + "V")]) : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1405caab!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/VehicleAdditionalStatus.vue
// module id = 2229
// module chunks = 1